const zh_cn = {
	"登录": "เข้าสู่ระบบ",
	"注册": "ลงทะเบียน",
	"选择语言": "ภาษา",
	"介绍人": "ผู้แนะนำ",
	"账号": "บัญชี",
	"密码": "รหัสผ่าน",
	"确认密码": "ยืนยันรหัสผ่าน",
	"真实姓名": "ชื่อ",
	"手机号码": "หมายเลขโทรศัพท์",
	"取款密码": "ถอนรหัสผ่าน",
	"验证码": "รหัส",
	"请输入密码": "กรุณากรอกรหัสผ่าน",
	"请输入验证码": "กรุณากรอกรหัสยืนยัน",
	"请输入账号": "กรุณากรอกบัญชี",
	"请重新获取验证码": "กรุณารับรหัสยืนยันอีกครั้ง",
	"正在登录中": "เข้าสู่ระบบ",
	"网络异常,请稍后再试": "ข้อผิดพลาดของเครือข่าย โปรดลองอีกครั้งในภายหลัง",
	"账号名": "ชื่อบัญชี",
	"余额": "สมดุล",
	"会员中心": "สมาชิก",
	"网上存款": "การฝากเงินออนไลน์",
	"网上提款": "การถอนเงินออนไลน์",
	"退出": "ออก",
	"请再次输入密码": "กรุณากรอกรหัสผ่านอีกครั้ง",
	"请输入姓名": "กรุณากรอกชื่อของคุณ",
	"请输入手机号": "กรุณากรอกหมายเลขโทรศัพท์ของคุณ",
	"请输入取款密码": "กรุณากรอกรหัสผ่านการถอน",
	"正在注册中": "การลงทะเบียน",
	"确定": "กำหนด",
	"注册成功": "เข้าสู่ระบบสำเร็จ",
	"热门优惠": "ส่วนลดยอดนิยม",
	"首页": "บ้าน",
	"查看活动": "ดูกิจกรรม",
	"正在获取活动列表": "รับรายการกิจกรรม",
	"暂无活动": "ไม่มีกิจกรรมในขณะนี้",
	"活动详情": "รายละเอียดกิจกรรม",
	"视讯直播": "วิดีโอสตรีมมิ่งสด",
	"直播类型": "ประเภทการถ่ายทอดสด",
	"热门": "เป็นที่นิยม",
	"推荐": "แนะนำ",
	"最新": "ปัจจุบัน",
	"全部": "ทั้งหมด",
	"获取类型中": "ประเภทการรับ",
	"获取具体信息中": "การได้รับข้อมูลเฉพาะ",
	"开始": "เริ่ม",
	"正在获取资源": "การได้มาซึ่งทรัพยากร",
	"正在努力加载中": "กำลังพยายามโหลด",
	"电子": "อิเล็กตรอน",
	"大厅": "ห้องโถง",
	"游戏类型": "ประเภทเกม",
	"游戏标签": "แท็กเกม",
	"错误的类型": "ผิดประเภท",
	"返回首页": "โฮมเพจ",
	"正在获取游戏列表": "กำลังรับรายชื่อเกม",
	"暂无游戏": "ขณะนี้ไม่มีเกมให้บริการ",
	"当前未登录,请先登录": "ขณะนี้ยังไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบก่อน",
	"联系我们": "ติดต่อเรา",
	"导航": "การนำทาง",
	"配置文件信息": "ข้อมูลโปรไฟล์",
	"常用功能": "ฟังก์ชั่นทั่วไป",
	"充值": "เติมเงิน",
	"提现": "การถอนเงิน",
	"功能列表": "ฟังก์ชั่น",
	"交易": "ธุรกรรม",
	"设置": "ติดตั้ง",
	"修改登入密码": "เปลี่ยนรหัสผ่านเข้าสู่ระบบ",
	"修改提现密码": "เปลี่ยนรหัสผ่านการถอน",
	"银行卡": "บัตรเครดิตธนาคาร",
	"若您先前透由手机号或社交平台登录站点，请您直接联系客服协助设置": "หากคุณเคยเข้าสู่ระบบไซต์ผ่านหมายเลขโทรศัพท์หรือแพลตฟอร์มโซเชียลมีเดียของคุณ โปรดติดต่อฝ่ายบริการลูกค้าโดยตรงเพื่อช่วยในการตั้งค่า",
	"旧密码": "รหัสผ่านเก่า",
	"请输入旧密码": "กรุณากรอกรหัสผ่านเก่าของคุณ",
	"设定新密码": "ตั้งรหัสผ่านใหม่",
	"确认新密码": "ยืนยันรหัสผ่านใหม่",
	"确认": "ยืนยัน",
	"下一步": "ขั้นตอนต่อไป",
	"交易功能": "ฟังก์ชั่นการซื้อขาย",
	"支付方式": "วิธีการชำระเงิน",
	"充值教学": "เติมพลังการสอน",
	"选择渠道": "เลือกช่อง",
	"存款金额": "เงินฝาก",
	"实际金额": "จำนวนเงินจริง",
	"提现币种": "สกุลเงินถอน",
	"提现银行卡": "การถอนบัตรธนาคาร",
	"新增": "เพิ่มใหม่",
	"提现金额": "จำนวนเงินที่ถอน",
	"提现金额范围": "ช่วงจำนวนเงินที่ถอน",
	"请输入金额": "กรุณากรอกจำนวนเงิน",
	"实际到帐": "ใบเสร็จรับเงินจริง",
	"一般手续费": "ค่าธรรมเนียมการจัดการทั่วไป",
	"强制手续费": "ค่าธรรมเนียมการจัดการภาคบังคับ",
	"上一步": "กลับ",
	"修改成功": "แก้ไขเรียบร้อยแล้ว",
	"修改中": "การปรับเปลี่ยน",
	"拼命加载中": "กำลังโหลดหมดหวัง",
	"编辑登录密码": "แก้ไขรหัสผ่านเข้าสู่ระบบ",
	"编辑提款密码": "แก้ไขรหัสผ่านการถอน",
	"如果您通过手机号码或社交平台登录网站，请联系向客户服务部门寻求帮助。": "หากคุณเข้าสู่ระบบเว็บไซต์ผ่านหมายเลขโทรศัพท์หรือแพลตฟอร์มโซเชียลมีเดียของคุณ โปรดติดต่อฝ่ายบริการลูกค้าเพื่อขอความช่วยเหลือ.",
	   "请输入新密码": "กรุณากรอกรหัสผ่านใหม่",
	"新密码不能和旧密码一致": "รหัสผ่านใหม่ไม่สามารถตรงกับรหัสผ่านเก่า",
	"两次输入密码不一致!": "รหัสผ่านทั้งสองที่ป้อนไม่ตรงกัน!",
	"请输入提款密码": "กรุณากรอกรหัสผ่านการถอน",
	"输入提款密码": "ป้อนรหัสผ่านการถอน",
	"请设置新的提款密码": "กรุณาตั้งรหัสผ่านการถอนเงินใหม่",
	"设置6位提款密码，并记住您的密码": "ตั้งรหัสผ่านการถอนเงิน 6 หลักและจำรหัสผ่านของคุณ",
	"请输入新的提款密码": "กรุณากรอกรหัสผ่านการถอนเงินใหม่",
	"存款": "เงินฝาก",
	"取款": "ถอน",
	"付款方式": "วิธีการชำระเงิน",
	"存款金额": "จำนวนเงินฝาก",
	"请输入金额": "กรุณากรอกจำนวนเงิน",
	"下一步": "ขั้นตอนต่อไป",
	"提款金额": "จำนวนเงินที่ถอน",
	"提款银行卡": "ถอนบัตรธนาคาร",
	"请输入您的银行卡号": "กรุณากรอกหมายเลขบัตรธนาคารของคุณ",
	"切换语言将会刷新页面": "การเปลี่ยนภาษาจะรีเฟรชหน้า",
	"充值方式": "วิธีการเติมเงิน",
	"取消": "การยกเลิก",
	"登录过期,是否重新登录": "การเข้าสู่ระบบหมดอายุ คุณต้องการเข้าสู่ระบบอีกครั้งหรือไม่",
	"系统提示": "ได้รับแจ้ง",
	"国家": "ประเทศ",
	"请输入": "กรุณากรอก",
	"请选择": "โปรดเลือก",
	"快速存款": "ฝากด่วน",
	 "加载更多":"โหลดเพิ่ม",
	"开始": "เล่น",
	"存取款":"การฝาก/ถอนเงิน",
	"存取款": "เงินฝาก",
	"加钱": "เพิ่มเงิน",
	"选择您的奖金": "เลือกโบนัสของคุณ",
	"100%,最高1500": "100% สูงถึง 1,500 เรียลบราซิล",
	"CASINO": "คาสิโน",
	"Select your lottery": "เลือกลอตเตอรีของคุณ",
	"don't want a lottery": "ไม่อยากถูกลอตเตอรี",
	"金额不得小于": "จำนวนเงินต้องไม่ต่ำกว่า",
	"金额不得大于": "จำนวนเงินต้องไม่มากกว่า",
	"加载失败": "โหลดล้มเหลว",
	"活动中心": "ศูนย์กิจกรรม",
	"**财富攀升-BRL的充值促销**": "**Wealth Climbing - โหลดโปรโมชั่นซ้ำใน BRL**",
	"在这个独特的活动中，我们为您提供了一个积累财富的无尽机会。无论你是初学者还是老手，每次充值都会为你带来不同级别的礼物以及更高级别的特权。": "ในกิจกรรมพิเศษนี้ เรามอบโอกาสอันไม่มีที่สิ้นสุดให้กับคุณในการสะสมความมั่งคั่ง ไม่ว่าคุณจะเป็นมือใหม่หรือผู้ใช้ที่มีประสบการณ์ การเติมเงินแต่ละครั้งจะทำให้คุณได้รับของขวัญในระดับที่แตกต่างกันและสิทธิพิเศษในระดับที่สูงขึ้น",
	"**青铜级别（青铜）**": "**เกรดบรอนซ์ (Bronze)**",
	"-重新加载的总金额：1.000-5.000 BRL": "- ยอดโหลดซ้ำทั้งหมด: 1.000 - 5.000 BRL",
	"-礼品的比例从5%逐渐增加到10%": "- สัดส่วนของของขวัญค่อยๆเพิ่มขึ้นจาก 5% เป็น 10%",
	"-第一次充值时，您将收到一份专属礼物。通往财富的大门是敞开的。每充值一次，就会收到更多的礼物。": "- ในการเติมเงินครั้งแรก คุณจะได้รับของขวัญพิเศษอยู่แล้ว ประตูสู่ความมั่งคั่งเปิดอยู่ ทุกครั้งที่ชาร์จเพิ่มเติม ของขวัญก็จะมามากขึ้น",
	"**银级（银级）**": "**Silver Level (SILVER)**",
	"-重新加载的总金额：5.001-15.000 BRL": "- ยอดโหลดซ้ำทั้งหมด: 5.001 - 15.000 BRL",
	"-礼品的比例从10%逐渐增加到15%": "- สัดส่วนของของขวัญค่อยๆเพิ่มขึ้นจาก 10% เป็น 15%",
	"-您已达到白银级别，您的财富将继续增长。充值越多，礼品比例就越高。重新加载更多，赚取更多！": "- คุณมาถึงระดับเงินแล้วซึ่งความมั่งคั่งของคุณยังคงเติบโตอย่างต่อเนื่อง ยิ่งคุณเติมเงินมากเท่าใด อัตราส่วนของขวัญก็จะยิ่งสูงขึ้น โหลดซ้ำมากขึ้น รับมากขึ้น!",
	"**黄金级别（Gold）**": "**ระดับทอง (GOLD)**",
	"-重新加载的总金额：15.001-30.000 BRL": "- ยอดโหลดซ้ำทั้งหมด: 15.001 - 30.000 BRL",
	"-礼品的比例从15%逐渐增加到18%": "- สัดส่วนของของขวัญค่อยๆ เพิ่มขึ้นจาก 15% เป็น 18%",
	"-你正走在富有的贵族之路上。成为金牌会员后，您将收到更多慷慨的礼物。你的财富注定会兴旺发达。": "- คุณอยู่บนเส้นทางแห่งขุนนาง ที่ซึ่งความมั่งคั่งอุดมสมบูรณ์ เมื่อเป็นสมาชิกระดับ Gold คุณจะได้รับของขวัญมากมายมากขึ้น ความมั่งคั่งของคุณถูกกำหนดให้เจริญรุ่งเรือง",
	"**白金级别（白金）**": "**ระดับแพลตตินัม (PLATINUM)**",
	"-随着冷却值的增加，会奖励更多的礼物": "- เมื่อค่าคูลดาวน์เพิ่มขึ้น ก็จะได้รับของขวัญมากขึ้น",
	"-重新加载的总金额：30.001-60.000 BRL": "- ยอดโหลดซ้ำทั้งหมด: 30.001 - 60.000 BRL",
	"-礼品的比例从18%逐渐增加到20%": "- สัดส่วนของของขวัญค่อยๆเพิ่มขึ้นจาก 18% เป็น 20%",
	"-在白金级别，您的充值将获得更高比例的礼物。你的理财能力会变得更加卓越，并获得丰厚的回报。": "- ที่ระดับแพลตตินัม การเติมเงินของคุณจะได้รับของขวัญตามสัดส่วนที่สูงขึ้น ความเชี่ยวชาญทางการเงินของคุณมีความโดดเด่นมากยิ่งขึ้นพร้อมรางวัลมากมาย",
	"**钻石级别（钻石）**": "**ระดับเพชร (DIAMOND)**",
	"-重新加载的总金额：60.001-100.000 BRL": "- ยอดโหลดซ้ำทั้งหมด: 60.001 - 100.000 BRL",
	"-礼品比例最高，达到20%": "- สัดส่วนของขวัญสูงสุดถึง 20%",
	"-这是荣誉的高度，是最终的选择。成为钻石会员后，您将享受最高比例的礼物，使您的财富加速增长，您的财务梦想即将实现。": "- นี่คือเกียรติยศอันสูงส่ง เป็นทางเลือกที่ดีที่สุด เมื่อเป็นสมาชิกระดับ Diamond คุณจะได้รับของขวัญในสัดส่วนสูงสุด นำความมั่งคั่งของคุณไปสู่การเติบโตอย่างรวดเร็ว และความฝันทางการเงินของคุณกำลังจะเป็นจริง",
	"不要错过这个难得的机会。攀登财富的阶梯，看着你的财富成倍增长。加入我们的“财富攀登”BRL补充促销活动，确保为实现您的财务目标提供最佳支持。财富之旅从你开始，回报不会停止增长，成功就在你身边！": `อย่าพลาดโอกาสอันเหลือเชื่อนี้ ปีนบันไดแห่งความมั่งคั่ง ดูความมั่งคั่งของคุณทวีคูณ เข้าร่วม "Wealth Climbing" ของเราในโปรโมชั่นเติมเงิน BRL และรับประกันการสนับสนุนที่เหมาะสมที่สุดเพื่อให้บรรลุเป้าหมายทางการเงินของคุณ การเดินทางสู่ความมั่งคั่งเริ่มต้นที่คุณ รางวัลไม่หยุดเติบโต ความสำเร็จอยู่เคียงข้างคุณ!`,
	"游戏记录": "บันทึกเกม",
	"交易记录": "บันทึกการทำธุรกรรม",
	"提交": "ส่ง",
	"游戏品牌": "แบรนด์เกม",
	"游戏名称": "ชื่อเกม",
	"下注时间": "เวลาเดิมพัน",
	"下注金额": "จำนวนเงินเดิมพัน",
	"输赢金额": "จำนวนชนะหรือแพ้",
	"上一页": "หน้าก่อนหน้า",
	"下一页": "หน้าต่อไป",
	"申请时间": "เวลาสมัคร",
	"状态": "สถานะ",
	"法规与合作伙伴": "กฎระเบียบและพันธมิตร",
	"为了注册本网站，用户必须接受一般条款和条件。如果条款和条件发生更新，现有用户可以选择在上述更新生效之前停止使用产品和服务，即在更新公布后至少两周。tambet911.com 由JajajEmmi B.V.运营，注册号为150790，地址为Abraham Mendez Chumaceiro Boulevard 03，Willemstad，Curacao。本网站由库拉索岛电子博彩公司许可和监管，许可证号为1668/JAZ。": "ในการลงทะเบียนสำหรับเว็บไซต์นี้ ผู้ใช้จะต้องยอมรับข้อกำหนดและเงื่อนไขทั่วไป หากมีการอัปเดตข้อกำหนดและเงื่อนไข ผู้ใช้ปัจจุบันสามารถเลือกที่จะหยุดใช้ผลิตภัณฑ์และบริการก่อนที่การอัปเดตดังกล่าวจะมีผลใช้งาน กล่าวคือ อย่างน้อยสองสัปดาห์หลังจากการประกาศการอัปเดต Tambet911.com ดำเนินการโดย JajajEmmi B.V. โดยมีหมายเลขทะเบียน 150790 และที่อยู่คือ Abraham Mendez Chumaceiro Boulevard 03, Willemstad, Curacao เว็บไซต์นี้ได้รับอนุญาตและควบคุมโดย Curacao Island Electronic Gaming Company โดยมีใบอนุญาตหมายเลข 1668/JAZ",
	"您可以使用用户名和密码登录": "You can log in with your username and password",
	"创建账户": "สร้างบัญชี",
	"银行信息": "ข้อมูลธนาคาร",
	"名称": "ชื่อ",
	"时间": "เวลา",
	"最小": "นาที",
	"最大": "แม็กซ์",
	"即时到账": "ใบเสร็จรับเงินทันที",
	"选择银行": "เลือกธนาคาร",
	"银行账号": "หมายเลขบัญชีธนาคาร",
	"请输入银行账号": "กรุณากรอกบัญชีธนาคารของคุณ",
	"金额": "จำนวน",
	"支出": "การจ่ายเงิน",
	"输入金额": "กรุณากรอกจำนวนเงิน",
	"暂无数据": "ขณะนี้ไม่มีข้อมูล",
	"获奖人": "การจัดอันดับ",
	"游戏榜": "แผนภูมิเกม",
	"新游戏榜": "แผนภูมิเกมใหม่",
	"热门游戏榜": "อันดับเกมยอดนิยม",
	"电子游戏": "เกมอิเล็กทรอนิกส์",
	"主要余额": "ยอดคงเหลือหลัก",
	"历史记录": "ประวัติศาสตร์",
	"付款名称": "ชื่อการชำระเงิน",
	"费用": "ค่าใช้จ่าย",
	"免费": "ฟรี",
	"立即生效": "มีผลทันที",
	"银行选择": "การเลือกธนาคาร",
	"银行账户": "บัญชีธนาคาร",
	"充值金额": "จำนวนการเติมเงิน",
	"收款名称": "ชื่อการชำระเงิน",
	"账号类型": "ประเภทบัญชี",
	"收账账号": "หมายเลขบัญชีเรียกเก็บเงิน",
	"CPF号码": "หมายเลขซีพีเอฟ",
	"提现密码": "ถอนรหัสผ่าน",
	"请输入名称": "กรุณากรอกชื่อ",
	"请选择类型": "กรุณากรอกประเภทการเลือก",
	"请输入CPF": "กรุณาระบุซีพีเอฟ",
	"请输入提现金额": "กรุณากรอกจำนวนเงินที่ถอน",
	"请输入正确的参数": "กรุณาป้อนพารามิเตอร์ที่ถูกต้อง",
	"收藏夹": "รายการโปรด",
	"敬请期待": "เร็วๆ นี้",
	"用户": "ผู้ใช้",
	"玩家": "ผู้เล่น",
	"时间": "เวลา",
	"赌场": "คาสิโน",
	"体育运动": "กีฬา",
	"促销": "โปรโมชั่น",
	"支持/法律": "การสนับสนุน/กฎหมาย",
	"加入我们的社区": "เข้าร่วมชุมชนของเรา",
	"赌场主页": "คาสิโน",
	"插槽": "เกมสล็อต",
	"现场赌场": "สด",
	"钓鱼游戏": "เกมตกปลา",
	"撞车游戏": "เกมแครช",
	"拱廊": "อาร์เคด",
	"更多的": "มากกว่า",
	"新版本": "ออกใหม่",
	"桌面游戏": "เกมบนโต๊ะ",
	"体育之家": "สปอร์ตโฮม",
	"会员俱乐部": "วีไอพีคลับ",
	"优惠促销": "โปรโมชั่น",
	"赌博意识": "ความรู้เรื่องการพนัน",
	"常问问题": "คำถามที่พบบ่อย",
	"条款和条件": "ข้อกำหนดและเงื่อนไข",
	"隐私政策": "นโยบายความเป็นส่วนตัว",
	"赞助和游戏责任":"ความรับผิดชอบในการสนับสนุนและการเล่นเกม",
	"页脚文本":"ในภูมิทัศน์ที่เปลี่ยนแปลงตลอดเวลาของเกมออนไลน์ ที่มีตัวเลือกมากมายและประสบการณ์ที่แตกต่างกัน GQ9Bet กลายเป็นสัญญาณแห่งนวัตกรรมและความตื่นเต้น ด้วยความมุ่งมั่นที่จะสร้างนิยามใหม่ของประสบการณ์การเดิมพันออนไลน์ GQ9Bet ถือเป็นเครื่องพิสูจน์ถึงเทคโนโลยีล้ำสมัย การบริการลูกค้าที่ไม่มีใครเทียบได้ และตัวเลือกการเล่นเกมที่หลากหลาย",
	"充电时间":"เวลาเติมเงิน",
	"订单号":"หมายเลขคำสั่งซื้อ",
	"充值金额":"จำนวนการเติมเงิน",
	"充值方式":"วิธีการเติมเงิน",
	"地位":"สถานะ",
  
	"搜索游戏": "ค้นหาเกม",
	"负责任的博彩": "การเล่นเกมอย่างมีความรับผิดชอบ",
	"快速链接":"ลิงค์ด่วน",
	"桌上游戏": "เกมบนโต๊ะ",
	"二十一点": "กระบอง",
	"扑克": "โป๊กเกอร์",
	"百家乐": "บาคาร่า",
	"掷骰子": "แครปส์",
	"奖金": "โบนัส",
	"赌场奖金": "โบนัสคาสิโน",
	"自由旋转": "หมุนฟรี",
	"免费投注": "เดิมพันฟรี",
	"信息": "ข้อมูล",
	"老虎机游戏":"เกมสล็อต",
	"赌场游戏":"เกมคาสิโน",
	"更多游戏":"เพิ่มเติม+",
	"特色平台":"แพลตฟอร์มเด่น",
	"游戏":"เกม",
	"乘数":"ตัวคูณ",
	"":"",
  
}
export default zh_cn



// WEBPACK FOOTER //
// ./src/utils/lang/config/zh_cn.js